var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFromToImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.510986,
    y: 0.5,
    width: 51.0201,
    height: 51,
    rx: 25.5,
    fill: "white",
    stroke: "#F9B233"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7849 20.9551C16.7849 20.3497 17.2821 19.8525 17.8875 19.8525L31.4438 19.8523L30.2331 18.6416C29.8655 18.274 29.779 17.6902 30.0601 17.2363C30.4492 16.6309 31.2708 16.5876 31.7465 17.0633L34.9897 20.3064C35.3572 20.674 35.3572 21.2361 34.9897 21.6038L31.7681 24.8253C31.2924 25.301 30.4708 25.2362 30.0817 24.6523C29.8006 24.22 29.8871 23.6146 30.2547 23.2471L31.4654 22.0363H17.8875C17.2605 22.0577 16.7848 21.5605 16.7848 20.9551L16.7849 20.9551ZM17.0444 31.7223L20.2659 34.9438C20.7415 35.4195 21.5632 35.3547 21.9523 34.7708C22.2334 34.3385 22.1469 33.7331 21.7793 33.3656L20.5686 32.1548L34.1681 32.1547C34.7735 32.1547 35.2708 31.6574 35.2708 31.0521C35.2708 30.4467 34.7735 29.9494 34.1681 29.9494H20.5902L21.8009 28.7387C22.1685 28.3712 22.2551 27.7873 21.9739 27.3334C21.5848 26.728 20.7632 26.6848 20.2875 27.1604L17.0659 30.382C16.6767 30.7709 16.6767 31.3547 17.0444 31.7223L17.0444 31.7223Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFromToImg);
export default __webpack_public_path__ + "static/media/from-to-img.d16b54310135a88f0c7e98c729177297.svg";
export { ForwardRef as ReactComponent };